import clsx from "clsx";
import { FC } from "react";
import { Image } from "@/components/Image/Image";
import { TechBlog } from "@/lib/contentful/contentModel/techBlog";
import { isNonNull } from "@/lib/guard";
import { shareToTwitter } from "@/lib/twitter";
import { BannerImage } from "../../../Article/BannerImage/BannerImage";
import { Content } from "../../../Article/Content/Content";
import { HatenaBookmarkButton } from "../../../HatenaBookmarkButton/HatenaBookmarkButton";
import { TableOfContentItem } from "../../../TableOfContent/type";
import { useAdjustHashPosition } from "../../../TableOfContent/useAdjustHashPosition";
import { Tags } from "../../../Tags/Tags";
import { PostAuthor } from "../PostAuthor/PostAuthor";
import { InfoCard } from "./InfoCard/InfoCard";

interface Props {
  post: TechBlog;
  date: string;
  uniquePageviews: number;
  tableOfContent: TableOfContentItem[];
  bodyHtml: string;
}

export const Article: FC<Props> = ({ post: data, date, tableOfContent, uniquePageviews, bodyHtml }) => {
  useAdjustHashPosition(tableOfContent, data.fields.body);

  return (
    <div>
      <BannerImage image={data.fields.image} />
      <div className="text-center">
        <h1 className="my-4 inline-block border-b-4 border-primary text-[32px] font-bold md:my-8">
          {data.fields.title}
        </h1>
      </div>
      <div className="mb-4 flex items-center gap-[24px] text-[14px] leading-[14px] text-[#666]">
        {date}
        <div className="flex flex-1 items-center gap-[8px]">
          <Image width={20} height={20} src={"/images/eye.svg"} alt="" />
          {uniquePageviews}
        </div>
        <div className="flex gap-4 md:gap-5">
          <HatenaBookmarkButton key={data.fields.slug} />
          <button
            onClick={() => data.fields.title && shareToTwitter(data.fields.title)}
            className="flex cursor-pointer items-center"
          >
            <Image
              width={30}
              height={30}
              src={"/favicon/x-icon.svg"}
              alt=""
              className="h-[20px] w-[20px] rounded-full object-cover sm:h-[30px] sm:w-[30px]"
            />
          </button>
        </div>
      </div>
      {data.fields.tags && <Tags tags={data.fields.tags.filter(isNonNull)} />}
      <div className="my-4 flex items-center justify-between md:mb-8">
        {data.fields.author && <PostAuthor author={data.fields.author} />}
      </div>
      <div className="flex gap-[12px]">
        <div
          id={"kdotdev-slug-content"}
          className={clsx("!w-full gap-[16px]", tableOfContent.length == 0 && "!w-full")}
        >
          {bodyHtml && <Content markdown={data.fields.body} bodyHtml={bodyHtml} />}
          {data.fields.tags && <Tags tags={data.fields.tags.filter(isNonNull)} />}
          <InfoCard />
        </div>
      </div>
    </div>
  );
};
